import { ESBA_DATE_FORMAT } from 'common';
import { tryParseDate } from 'converter';
import { format } from 'date-fns';
import { Paragraph } from 'evergreen-ui';
import React from 'react';
import { Referral } from 'referral';

type RequestedDateRenderer = {
    referral: Partial<Referral>
}
export const SubmittedDateRenderer = ({ referral }: RequestedDateRenderer) => {
    const date = tryParseDate(referral.requestDate);
    if (date) {
        return (
            <Paragraph className="portal-ev-tr-td" size={500}>{format(date, ESBA_DATE_FORMAT)}</Paragraph>
        )
    }
    return null;
}
